import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import SunnyPlugin from '@nextnet/sunny-ui';
import "@nextnet/sunny-ui/dist/sunny-ui.css";
import Clipboard from 'v-clipboard'

Vue.config.productionTip = false;

const vueOpt = {
  router,
  store,
  render: h => h(App)
};
Vue.use(Clipboard)
Vue.use(SunnyPlugin, vueOpt);
new Vue(vueOpt).$mount('#app')
